/**
 * Created by dingkang.li on 2018/2/28.
 */
const store = localStorage;

const Storage = {}

Storage.setStorage = function (key, value) {
  return store.setItem(key, JSON.stringify(value))
}

Storage.getStorage = function (key) {
  return JSON.parse(store.getItem(key))
}

Storage.clearStorage = function (key) {
  store.removeItem(key)
}

Storage.clearAllStorage = function () {
  store.clear()
}

export default Storage



// WEBPACK FOOTER //
// ./src/utils/storage.js